// const baseUrl = 'http://localhost:8099/';
const baseUrl = window.location.origin.includes("vclick.vn") ? 'https://apibeta.vclick.vn/' : 'https://apivclickv3.topdev.space/'; // serve dev test
//const baseUrl = 'https://apibeta.vclick.vn/';
//const baseUrl = 'https://apivclickv3.topdev.site/';

export default baseUrl